import { apiGet } from 'api';
import { GetReasonsForLateResponseResponse } from '../../types';

export const getReasonsForLateResponse = (): Promise<GetReasonsForLateResponseResponse> =>
  apiGet<GetReasonsForLateResponseResponse>('reasonsforlateresponse');
